import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IUnitDetailStats } from '@apps-common/types/portal/unit'

export const getUnitDetailStats = async (id: string): Promise<IUnitDetailStats> =>
  axios.get(`/Unit/GetUnitStats?unitId=${id}`).then((res) => res.data?.data)

type QueryFnType = typeof getUnitDetailStats

type Props = {
  config?: QueryConfig<QueryFnType>
  id: string | null
}

export const useGetUnitDetailStats = ({ config, id }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: ['getUnitDetailStats', id],
    queryFn: () => getUnitDetailStats(id || '')
  })
